import { useAuth } from '@clerk/nextjs';
import { useQuery } from '@tanstack/react-query';
import { Query } from '@web/constants/query';
import axios from 'axios';

type ApiResponse = {
  success: boolean;
  token: string;
};

export function useIntegrationToken() {
  const { orgId } = useAuth();

  return useQuery({
    queryKey: [Query.AppKeys['integration-token'], { orgId }],
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    enabled: !!orgId,
    retry: false,
    queryFn: async () => {
      const resp = await axios.get<ApiResponse>(`${process.env.NEXT_PUBLIC_API_APP_ENDPOINT}/crm/org`);
      return resp.data.token;
    },
  });
}
